/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { EventSubject } from '../utils/event-subject.js';
import { setupCDSGlobal } from '../utils/global.js';
import { LogService } from './log.service.js';
const stateUpdates = new EventSubject();
stateUpdates.listener = document.addEventListener('CDS_STATE_UPDATE', (e) => stateUpdates.emit(e.detail));
export class GlobalStateService {
    static get state() {
        setupCDSGlobal();
        return window.CDS._state;
    }
    static getValue(key) {
        return GlobalStateService.state[key];
    }
    static setValue(key, val) {
        GlobalStateService.state[key] = val;
    }
    static log() {
        LogService.log(JSON.stringify(GlobalStateService.state, null, 2));
    }
}
GlobalStateService.stateUpdates = stateUpdates.toEventObservable();
